export const mapCartItemToGAItem = (i, idx) => ({
  item_id: i.productCode,
  item_name: i.productDescription,
  currency: 'ARS',
  index: idx,
  item_brand: i.brand,
  price: i.productPrice,
  quantity: i.quantity
});
